import i18n from '../i18n/config';
import { resolveAppLanguage } from '../constants/languages';

let pendingLanguage = null;

export const getPendingAppLanguage = () => pendingLanguage;

export const applyAppLanguage = async (languageCode, i18nInstance = i18n) => {
  const next = resolveAppLanguage(languageCode);
  pendingLanguage = next;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('preferredLanguage', next);
    document.documentElement.lang = next;
    document.dir = next === 'ar' ? 'rtl' : 'ltr';
  }
  await i18nInstance.changeLanguage(next);
  return next;
};
